import { useRef } from 'react';

import { VoteButton } from '@/molecules';

import { routes } from '@/lib/routes';
import Accesorios from '../Accesorios/Accesorios';

import type { TypeImageWordpress } from '@/components/types';
import type { FunctionComponent } from 'react';

type TypeVotacionesProps = {
  id: string;
  bloque: {
    votacion: {
      campaignId: number;
      voteData: {
        voteStartDate: string;
        voteEndDate: string;
        categorias: Array<{
          backgroundColor: string;
          categoryTitle: string;
          description?: string;
          categoryVote: {
            categoryId: number;
            slug: string;
          };
          destacados: Array<{
            sellerId: number;
            slug: string;
            sellersMirakl: {
              shopName: string;
              votationImage?: TypeImageWordpress;
            };
          }>;
        }>;
      };
    };
  };
};

/**
 * Votaciones
 */
const Votaciones: FunctionComponent<TypeVotacionesProps> = ({
  id,
  bloque,
}: TypeVotacionesProps) => {
  const endDate = Date.parse(bloque.votacion.voteData.voteEndDate);
  const nowDate = Date.now();

  const voteActive = useRef(endDate > nowDate).current;

  return (
    <>
      {bloque.votacion.voteData.categorias.map((category, index) => (
        <Accesorios
          key={`${category.categoryTitle}_${index}`}
          id={`${category.categoryTitle}_${index}_${id}`}
          bloque={{
            backgroundColorString: category.backgroundColor,
            backgroundColorStringCard: category.backgroundColor,
            papelRasgado: { zona: 'none' },
            cardStyle: 'marca',
            titulo: category.categoryTitle,
            headingType: 'h2',
            headingSize: 'u-headline--h2',
            titleAlign: 'text-center',
            itemsDesktop: 4,
            itemsTablet: 4,
            itemsMobile: 2,
            categorias: category.destacados.map((destacado, index) => ({
              titulo: destacado.sellersMirakl.shopName,
              imagen: destacado.sellersMirakl.votationImage,
              link: routes.sellers.seller(destacado.slug),
              ...(voteActive && {
                extraButton: () => (
                  <VoteButton
                    key={`voteButton-${destacado.slug}-${index}`}
                    campaign={bloque.votacion.campaignId}
                    category={category.categoryVote.categoryId}
                    seller={destacado.sellerId}
                  />
                ),
              }),
            })),
            listOfCategories: { title: undefined, categories: undefined },
            ...(voteActive && {
              message: 'Recuerda, tienes máximo un voto en esta categoría',
            }),
            contentAfterAccessories: {
              textStyle: 'default',
              text: category.description,
              headingType: 'p',
              label: '+ INFO',
              link: {
                url: `${routes.aceleracionArtesanos}/${category.categoryVote.slug}`,
              },
              size: 'normal',
              style: 'primary',
            },
          }}
        />
      ))}
      <div className="px-4">
        <hr className="u-wrapper mt-8 border-dashed border-primary-900" />
      </div>
    </>
  );
};

export default Votaciones;
